import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpagentComponent } from './spagent/spagent.component';
import { SpagentRoutingModule } from './spagent-routing.module';
import { CallbackComponent } from './callback/callback.component';

@NgModule({
    imports: [
        CommonModule,
        SpagentRoutingModule,
    ],
    declarations: [
        SpagentComponent,
        CallbackComponent],
})
export class SpagentModule { }
